import React, { useMemo } from "react";
import "./SessionsTable.css";
import Pagination from "../../Common/Pagination";
import HighlightText from "../../Common/HighlightText";
import { IconChatBubblesBtn, IconSearch } from "../../Common/EmcureReactIcons";

const SessionsTable = ({
  paginatedSessions,
  currentPage,
  sessionsData,
  itemsPerPage,
  sessionSearchQuery,
  onSessionSearchInput,
  onPageChange,
  onViewMessages,
  formatDate,
  loadingSessions,
  dateRangePicker,
}) => {
  // Local search filter and date-wise sort (newest first by last_activity, then created_at)
  // Sessions are now filtered server-side. Sort them newest first.
  const sortedSessions = useMemo(() => {
    return [...paginatedSessions].sort((a, b) => {
      const dateA = new Date(a.last_activity || a.created_at || 0).getTime();
      const dateB = new Date(b.last_activity || b.created_at || 0).getTime();
      return dateB - dateA;
    });
  }, [paginatedSessions]);

  return (
    <>
      <div className="admin-title-wrapper">
        <div className="admin-title-left">
          <h2 className="admin-title">Sessions</h2>
          <p className="admin-title-sub">
            View and manage all user sessions
          </p>
        </div>
        <div className="admin-title-right">
          <div className="admin-title-actions">
            <div className="sessions-search-wrapper">
              <input
                type="text"
                className="sessions-search-input"
                placeholder="Search by User ID or Session ID..."
                value={sessionSearchQuery}
                onChange={(e) => onSessionSearchInput(e.target.value)}
              />
              <IconSearch className="sessions-search-icon" width={16} height={16} />
            </div>
            {dateRangePicker}
          </div>
        </div>
      </div>
      <div className="admin-list-table-shell">
        <div className="admin-list-table-scroll data-table-container admin-dashboard-data-table-container">
          <div className="data-table-layout sessions-admin-table-layout">
              {loadingSessions ? (
                <div style={{ padding: '40px', textAlign: 'center', color: '#9CA3AF' }}>
                  Loading sessions...
                </div>
              ) : sortedSessions.length === 0 ? (
                <div style={{ padding: '40px', textAlign: 'center', color: '#9CA3AF' }}>
                  {sessionSearchQuery ? 'No sessions match your search' : 'No sessions found'}
                </div>
              ) : (
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Session ID</th>
                      <th>User ID</th>
                      <th>Created At</th>
                      <th>Last Activity</th>
                      <th>Messages</th>
                      <th className="actions-col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedSessions.map((session) => (
                      <tr key={session.session_id}>
                        <td>
                          <HighlightText 
                            text={session.session_id} 
                            highlight={sessionSearchQuery}
                          />
                        </td>
                        <td>
                          <HighlightText 
                            text={session.user_id} 
                            highlight={sessionSearchQuery}
                          />
                        </td>
                        <td>{formatDate(session.created_at)}</td>
                        <td>{formatDate(session.last_activity)}</td>
                        <td>{session.message_count}</td>
                        <td>
                          <button 
                            className="view-messages-btn"
                            onClick={() => onViewMessages(session.session_id, session.user_id)}
                            title="View Chat History"
                          >
                            <IconChatBubblesBtn width={18} height={18} />
                            <span>Show Messages</span>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
          </div>
        </div>

        <div className="admin-table-pagination">
          <Pagination
            page={currentPage}
            totalPages={sessionsData.total_pages}
            totalItems={sessionsData.total}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
            showInfo={true}
          />
        </div>
      </div>
    </>
  );
};

export default SessionsTable;
